import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CustomerEditRequestBody, CustomerEditResponse } from "./types";

export class CustomerEditAPI extends BaseAPI<
  CustomerEditRequestBody,
  CustomerEditResponse
> {
  protected route = ApiRoutes.customer.edit;
  protected method = RequestMethod.POST;
  protected params = ["customerId"];
}
